import { Link } from 'react-router-dom';
import { textToMentionParts } from '@/utils/mentions';
import { cn } from '@/lib/utils';

interface MentionTextProps {
  text: string;
  className?: string;
}

export function MentionText({ text, className }: MentionTextProps) {
  const parts = textToMentionParts(text);

  return (
    <span className={cn("break-words", className)}>
      {parts.map((part, index) => {
        if (part.type === 'mention') {
          return (
            <Link
              key={index}
              to={`/profile/${part.content}`}
              className="text-primary hover:underline font-medium"
              onClick={(e) => e.stopPropagation()}
            >
              @{part.content}
            </Link>
          );
        }
        return <span key={index}>{part.content}</span>;
      })}
    </span>
  );
}
